import { validate } from './validate';
import {
  refreshAdministrativeAreaForModel,
  setAddressEntryMode,
} from './address-country-fields';

document.addEventListener('DOMContentLoaded', function () {
  function toggleNewAddressGroup(model) {
    const toggle = document.querySelector(
      `[data-address-toggle][data-address-model="${model}"]`
    );
    if (!toggle) return;
    const group = document.querySelector(`[data-new-address-group="${model}"]`);
    const active = toggle.value === '';
    // console.log(model, toggle, group, active);
    if (group) {
      group.style.display = active ? 'flex' : 'none';
    }
  }

  // Toggle new address group
  document.querySelectorAll('[data-address-toggle]').forEach(function (el) {
    el.addEventListener('change', function (e) {
      e.preventDefault();
      const model = el.getAttribute('data-address-model');
      // console.log(model, el.value);
      toggleNewAddressGroup(model);
    });
  });

  // Initial toggle
  toggleNewAddressGroup('shippingAddress');
  toggleNewAddressGroup('billingAddress');

  // Toggle billing address group when shipping address group is toggled
  const billingAddressSameAsShippingToggle = document.querySelector(
    '[data-billing-address-same-as-shipping]'
  );
  if (billingAddressSameAsShippingToggle) {
    billingAddressSameAsShippingToggle.addEventListener('change', function (e) {
      const billingGroup = document.querySelector(
        '[data-billing-address-group]'
      );
      if (billingGroup) {
        billingGroup.style.display = this.checked ? 'none' : '';
        if (!this.checked) {
          document.querySelector(
            '[data-address-toggle][data-address-model="billingAddress"]'
          ).dataset.touched = '';
        }
      }
    });
  }

  // Initial toggle
  if (billingAddressSameAsShippingToggle) {
    billingAddressSameAsShippingToggle.dispatchEvent(new Event('change'));
  }

  const billingPrimaryHint = document.querySelector(
    '[data-billing-primary-hint]'
  );
  const primaryBillingAddressId =
    billingPrimaryHint?.dataset.primaryBillingAddressId ?? '';

  function isNewAddressFormVisible(model) {
    const group = document.querySelector(`[data-new-address-group="${model}"]`);
    if (!group) return false;
    return window.getComputedStyle(group).display !== 'none';
  }

  function updateBillingPrimaryHint() {
    if (!billingPrimaryHint || !primaryBillingAddressId) {
      if (billingPrimaryHint) billingPrimaryHint.hidden = true;
      return;
    }

    const sameAsShipping =
      document.getElementById('billingAddressSameAsShipping')?.checked ?? true;
    const billingModel = sameAsShipping ? 'shippingAddress' : 'billingAddress';
    const addressToggle = document.querySelector(
      `[data-address-toggle][data-address-model="${billingModel}"]`
    );
    const effectiveBillingAddressId = addressToggle?.value ?? '';

    if (effectiveBillingAddressId === 'initial') {
      billingPrimaryHint.hidden = true;
      return;
    }

    let isDifferentFromPrimary = false;

    if (effectiveBillingAddressId === '') {
      isDifferentFromPrimary = isNewAddressFormVisible(billingModel);
    } else {
      isDifferentFromPrimary =
        String(effectiveBillingAddressId) !== String(primaryBillingAddressId);
    }

    billingPrimaryHint.hidden = !isDifferentFromPrimary;
  }

  if (billingPrimaryHint && primaryBillingAddressId) {
    const shippingToggle = document.querySelector(
      '[data-address-toggle][data-address-model="shippingAddress"]'
    );
    const billingToggle = document.querySelector(
      '[data-address-toggle][data-address-model="billingAddress"]'
    );

    if (billingAddressSameAsShippingToggle) {
      billingAddressSameAsShippingToggle.addEventListener(
        'change',
        updateBillingPrimaryHint
      );
    }
    if (shippingToggle) {
      shippingToggle.addEventListener('change', updateBillingPrimaryHint);
    }
    if (billingToggle) {
      billingToggle.addEventListener('change', updateBillingPrimaryHint);
    }

    updateBillingPrimaryHint();
  }

  // Manual address toggle
  function toggleManualAddress(model, active = true) {
    setAddressEntryMode(model, active);

    if (active) {
      refreshAdministrativeAreaForModel(model);
    }
  }

  const manualAddressTogglesOff = document.querySelectorAll(
    '[data-manual-address-toggle-off]'
  );
  manualAddressTogglesOff.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const model = toggle.getAttribute('data-address-model');
      toggleManualAddress(model, true);
    });
  });

  const manualAddressTogglesOn = document.querySelectorAll(
    '[data-manual-address-toggle-on]'
  );
  manualAddressTogglesOn.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const model = toggle.getAttribute('data-address-model');
      toggleManualAddress(model, false);
    });
  });

  function getInvalidEditUrlForAddress(input) {
    const value = String(input.value ?? '').trim();
    if (!value || value === 'initial') {
      return null;
    }

    const dropdown = input.closest('[data-dropdown-select]');
    if (!dropdown) {
      return null;
    }

    const item = dropdown.querySelector(
      `[data-dropdown-select-item-value="${CSS.escape(value)}"]`
    );

    return item?.getAttribute('data-invalid-edit-url') || null;
  }

  function validateSavedAddressId(value, input) {
    const editUrl = getInvalidEditUrlForAddress(input);
    if (!editUrl) {
      return { valid: true };
    }

    return {
      valid: false,
      message: `This address is invalid, <a href="${editUrl}">please edit to continue</a>.`,
    };
  }

  function validateCheckoutSavedAddressId(value, input, form) {
    const name = input.getAttribute('name');

    if (
      name === 'billingAddressId' &&
      form.querySelector('#billingAddressSameAsShipping')?.checked
    ) {
      return { valid: true };
    }

    return validateSavedAddressId(value, input);
  }

  const checkoutAddressForm = document.getElementById('checkout_addresses');
  const savedAddressValidators = {
    shippingAddressId: validateCheckoutSavedAddressId,
    billingAddressId: validateCheckoutSavedAddressId,
  };

  function updateSavedAddressNotice(input) {
    if (!input || !checkoutAddressForm) {
      return false;
    }

    const dropdown = input.closest('[data-dropdown-select]');
    const notice = dropdown?.querySelector('[data-saved-address-error]');
    const result = validateCheckoutSavedAddressId(
      input.value,
      input,
      checkoutAddressForm
    );

    if (notice) {
      if (result.valid) {
        notice.hidden = true;
        notice.innerHTML = '';
        dropdown?.classList.remove('dropdown-select--has-error');
      } else {
        notice.hidden = false;
        notice.innerHTML = result.message;
        dropdown?.classList.add('dropdown-select--has-error');
      }
    }

    input.setAttribute('aria-invalid', String(!result.valid));

    return result.valid;
  }

  function initSavedAddressValidation() {
    if (!checkoutAddressForm) {
      return;
    }

    checkoutAddressForm
      .querySelectorAll('[data-address-toggle]')
      .forEach((input) => {
        input.addEventListener('change', () => {
          updateSavedAddressNotice(input);
        });
        updateSavedAddressNotice(input);
      });

    if (billingAddressSameAsShippingToggle) {
      billingAddressSameAsShippingToggle.addEventListener('change', () => {
        checkoutAddressForm
          .querySelectorAll('[data-address-toggle]')
          .forEach(updateSavedAddressNotice);
      });
    }

    checkoutAddressForm.addEventListener(
      'submit',
      () => {
        let firstInvalidDropdown = null;

        checkoutAddressForm
          .querySelectorAll('[data-address-toggle]')
          .forEach((input) => {
            if (!updateSavedAddressNotice(input) && !firstInvalidDropdown) {
              firstInvalidDropdown = input.closest('[data-dropdown-select]');
            }
          });

        if (firstInvalidDropdown) {
          const prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;
          firstInvalidDropdown.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'center',
          });
        }
      },
      true
    );
  }

  // Validate the form
  validate(checkoutAddressForm, {
    customValidators: savedAddressValidators,
    rules: {
      // shippingAddressId: ['required'],
      'shippingAddress[searchAddress]': [
        [
          'requiredIfAll',
          [
            ['shippingAddress[useAddressFinder]', '1'],
            ['shippingAddressId', ''],
          ],
        ],
      ],
      'shippingAddress[fullName]': [['requiredIf', 'shippingAddressId', '']],
      'shippingAddress[fields][addressType]': [
        ['requiredIf', 'shippingAddressId', ''],
      ],
      'shippingAddress[countryCode]': [['requiredIf', 'shippingAddressId', '']],
      'shippingAddress[addressLine1]': [
        ['requiredIf', 'shippingAddressId', ''],
      ],
      'shippingAddress[locality]': [['requiredIf', 'shippingAddressId', '']],
      'shippingAddress[administrativeArea]': [
        [
          'requiredIfAll',
          [
            ['shippingAddressId', ''],
            ['shippingAddress[countryCode]', 'AU'],
          ],
        ],
      ],
      'shippingAddress[postalCode]': [
        ['requiredIf', 'shippingAddressId', ''],
        ['postcodeIfAu', 'shippingAddress[countryCode]'],
      ],
      'shippingAddress[fields][phone]': ['phoneNumber'],
      // billingAddressId: [['requiredIf', 'billingAddressSameAsShipping', false]],
      'billingAddress[searchAddress]': [
        [
          'requiredIfAll',
          [
            ['billingAddressSameAsShipping', false],
            ['billingAddressId', ''],
            ['billingAddress[useAddressFinder]', '1'],
          ],
        ],
      ],
      'billingAddress[fullName]': [
        [
          'requiredIfAll',
          [
            ['billingAddressSameAsShipping', false],
            ['billingAddressId', ''],
          ],
        ],
      ],
      'billingAddress[fields][addressType]': [
        [
          'requiredIfAll',
          [
            ['billingAddressSameAsShipping', false],
            ['billingAddressId', ''],
          ],
        ],
      ],
      'billingAddress[countryCode]': [
        [
          'requiredIfAll',
          [
            ['billingAddressSameAsShipping', false],
            ['billingAddressId', ''],
          ],
        ],
      ],
      'billingAddress[addressLine1]': [
        [
          'requiredIfAll',
          [
            ['billingAddressSameAsShipping', false],
            ['billingAddressId', ''],
          ],
        ],
      ],
      'billingAddress[locality]': [
        [
          'requiredIfAll',
          [
            ['billingAddressSameAsShipping', false],
            ['billingAddressId', ''],
          ],
        ],
      ],
      'billingAddress[administrativeArea]': [
        [
          'requiredIfAll',
          [
            ['billingAddressSameAsShipping', false],
            ['billingAddressId', ''],
            ['billingAddress[countryCode]', 'AU'],
          ],
        ],
      ],
      'billingAddress[postalCode]': [
        [
          'requiredIfAll',
          [
            ['billingAddressSameAsShipping', false],
            ['billingAddressId', ''],
          ],
        ],
        ['postcodeIfAu', 'billingAddress[countryCode]'],
      ],
      'billingAddress[fields][phone]': ['phoneNumber'],
    },
  });

  initSavedAddressValidation();
});
